import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { Link as FoundationsLink } from 'foundations-components/transitional/components/Link';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const Link = _ref => {
  let restWithSpacingProps = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  return /*#__PURE__*/_jsx(FoundationsLink, Object.assign({}, rest, spacingProps));
};